import React from 'react';
import { opcionesSponsor } from './cvuUtils';

const SELECT_CLS = 'h-8 px-2 border border-slate-300 rounded-md text-xs bg-white focus:outline-none focus:ring-2 focus:ring-blue-200';

// Filtros de la tabla de CVUs: banco sponsor + estado (por defecto, todos).
export const CvuFiltrosBar = ({ cvus, filtros, onChange, testid = 'cvu-filtros', total }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid={testid}>
    <label className="flex items-center gap-1.5 text-xs text-slate-500">
      Banco sponsor
      <select className={SELECT_CLS} value={filtros.sponsor} onChange={(e) => onChange({ ...filtros, sponsor: e.target.value })} data-testid={`${testid}-sponsor`}>
        <option value="todos">Todos</option>
        {opcionesSponsor(cvus).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </label>
    <label className="flex items-center gap-1.5 text-xs text-slate-500">
      Estado
      <select className={SELECT_CLS} value={filtros.estado} onChange={(e) => onChange({ ...filtros, estado: e.target.value })} data-testid={`${testid}-estado`}>
        <option value="todos">Todos</option>
        <option value="activos">Activos</option>
        <option value="inactivos">Inactivos</option>
      </select>
    </label>
    {typeof total === 'number' && (
      <span className="text-xs text-slate-400" data-testid={`${testid}-conteo`}>Mostrando {total} de {cvus.length}</span>
    )}
  </div>
);
